import { Injectable } from '@angular/core';
import { ApiService } from './api.base.service';

@Injectable({ providedIn: 'root' })
export class IotaService {
    private baseUrl = 'api/iota';

    constructor(private apiService: ApiService) {}

    async getNotarizationExplorerUrl(documentProcessId: number): Promise<string | null> {
        try {
            const result = await this.apiService.get<{ explorerUrl: string; success: boolean }>(
                `${this.baseUrl}/notarizations/${documentProcessId}`
            );
            if (result && result.success) {
                return result.explorerUrl;
            }
            return null;
        } catch {
            return null;
        }
    }
}
